module.exports = __webpack_public_path__ + "img/logo-color-64x64.05b2e26f.png";